import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ordersAPI } from '../api/vendly';
import styles from './ProcessingPage.module.css';

export default function ProcessingPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing'); // processing | done | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!state) { navigate('/shop'); return; }

    // Place the order with the backend, min 10s display
    const minTime = new Promise(res => setTimeout(res, 10000));

    const placeOrder = ordersAPI.create({
      items: state.cartItems.map(i => ({ id: i.id, qty: i.qty })),
      address: state.address,
      paymentMethod: state.payMethod,
    });

    Promise.all([minTime, placeOrder])
      .then(([, res]) => {
        setStatus('done');
        setTimeout(() => {
          navigate('/checkout/confirm', {
            state: {
              orderId:      res.data.order.id,
              payMethod:    state.payMethod,
              grandTotal:   res.data.order.total,
              deliveryDate: state.deliveryDate,
              address:      state.address,
              items:        state.cartItems,
              bank:         res.data.bank,
            }
          });
        }, 800);
      })
      .catch(err => {
        setStatus('error');
        setErrorMsg(err.response?.data?.error || 'Something went wrong. Please try again.');
      });
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.center}>

        {/* Glowing V */}
        <div className={`${styles.logoWrap} ${status === 'done' ? styles.logoWrapDone : status === 'error' ? styles.logoWrapError : ''}`}>
          <div className={styles.ring1} />
          <div className={styles.ring2} />
          <div className={styles.ring3} />
          <span className={styles.vLetter}>
            {status === 'done' ? (
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            ) : status === 'error' ? '!' : 'V'}
          </span>
        </div>

        {status === 'processing' && (
          <>
            <h2 className={styles.title}>Processing your order…</h2>
            <p className={styles.sub}>Please don't close this page</p>
          </>
        )}

        {status === 'done' && (
          <>
            <h2 className={styles.titleDone}>Order placed! 🎉</h2>
            <p className={styles.sub}>Redirecting you now…</p>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 className={styles.titleError}>Something went wrong</h2>
            <p className={styles.errorMsg}>{errorMsg}</p>
            <button className={styles.retryBtn} onClick={() => navigate('/checkout')}>
              ← Back to checkout
            </button>
          </>
        )}

        <p className={styles.secure}>🔒 Your connection is encrypted and secure</p>
      </div>
    </div>
  );
}
